import React from 'react';

function Copyright(){
	
	return(
		<div className="grid-x copyright bt1-ccc bb1-ccc ptb-20 mlr-10 bg-eee">
			<div className="large-12 medium-12 small-12 cell text-center">
					<div className="font-orbitron font-size-16 font-weight-800 letter-spacing-0px uppercase italic">ROMERGENCE</div>
					<div className="font-orbitron font-size-12 font-weight-400 letter-spacing-1px italic pt-5">De Ortu Abyssi</div>
					<div className="font-poppins font-size-14 font-weight-400 txt-333 uppercase pt-5">&copy;&nbsp;2024-2025</div>
					<div className="font-poppins font-size-14 font-weight-400 txt-333  pt-20">Update: 10/31/2025</div>
			</div>
		</div>
	);
	
}

export default Copyright;